import type { Location } from '@core/locations-types';
import { OfferKind, type TOfferKind, type TOfferStatus } from '@core/offers-types';

export type OfferSelectDialogItemBase = {
  id: number;
  title: string;
  kind: TOfferKind;
  status: TOfferStatus;
  guid: string;
  department?: string | null;
  location?: string | null;
  locationIds?: number[] | null;
  locations?: Location[] | null;
  country?: string | null;
  countryCode?: string | null;
};

export type OfferSelectDialogItemExtended = OfferSelectDialogItemBase & {
  department: string | null;
  location: string | null;
  country: string | null;
  countryCode: string | null;
};

export type OfferSelectDialogItem = OfferSelectDialogItemBase | OfferSelectDialogItemExtended;

export enum SelectionListGroup {
  Job = OfferKind.Job,
  TalentPool = OfferKind.TalentPool,
  JobTemplate = 'job_template',
}

export type SelectionList = {
  id: number;
  title: string;
  status?: TOfferStatus;
  kind?: TOfferKind;
  guid?: string;
  department?: string | null;
  location?: string | null;
  locationIds?: number[] | null;
  locations?: Location[] | null;
  country?: string | null;
  countryCode?: string | null;
};
